import { StatService } from '@/services/stat.service'
import { AboutService } from '@/services/about.service'
import { ContactService } from '@/services/contactService.service'
import { HTTP_STATUS_CODES } from '@/configs/constants.ts'
import { commitPaginationFromMeta, commitPaginationFromLinks, showErrorToast } from './helpers'

let requestStatsInFlight = null
const REQUEST_STATS_CACHE_KEY = 'stats'
const REQUEST_STATS_CACHE_TS_KEY = 'statsFetchedAt'
const REQUEST_STATS_DEFAULT_MAX_AGE_MS = 60 * 1000

export const miscActions = {
  hydrateRequestStatsFromSession({ commit }) {
    try {
      const statsRaw = sessionStorage.getItem(REQUEST_STATS_CACHE_KEY)
      if (!statsRaw) {
        return null
      }

      const parsed = JSON.parse(statsRaw)
      if (parsed && typeof parsed === 'object') {
        commit('SET_REQUEST_STATS', parsed)
        return parsed
      }
    } catch (e) {
      sessionStorage.removeItem(REQUEST_STATS_CACHE_KEY)
    }

    return null
  },

  async loadRequestStats({ commit, dispatch }, options = {}) {
    const { force = false, useCache = false, maxAgeMs = REQUEST_STATS_DEFAULT_MAX_AGE_MS } = options

    if (!force && useCache) {
      const cachedStats = await dispatch('hydrateRequestStatsFromSession')
      const cachedAt = Number(sessionStorage.getItem(REQUEST_STATS_CACHE_TS_KEY) || 0)
      const cacheIsFresh = cachedAt && Date.now() - cachedAt < maxAgeMs

      if (cachedStats && cacheIsFresh) {
        return cachedStats
      }
    }

    if (requestStatsInFlight) {
      return requestStatsInFlight
    }

    requestStatsInFlight = (async () => {
      try {
        const response = await StatService.requestCounts()
        commit('SET_REQUEST_STATS', response.data)
        const jsonArray = JSON.stringify(response.data)

        let statsCount = 0

        for (let c in response.data) {
          if (c !== 'orders' && c !== 'inactive_users' && c !== 'customer_numbers_to_approve' && c !== 'approve_indirect') {
            statsCount += response.data[c]
          }
        }

        sessionStorage.setItem(REQUEST_STATS_CACHE_KEY, jsonArray)
        sessionStorage.setItem('statsCount', statsCount)
        sessionStorage.setItem(REQUEST_STATS_CACHE_TS_KEY, String(Date.now()))
        return response.data
      } catch (err) {
        showErrorToast(err)
        return err
      } finally {
        requestStatsInFlight = null
      }
    })()

    return requestStatsInFlight
  },

  async loadAboutList({ commit }, page = 1) {
    const response = await AboutService.list(page)

    if (response.status == HTTP_STATUS_CODES.OK) {
      const sorted = response.data.data.sort((a, b) => a.order - b.order)
      commit('SET_ABOUT_LIST', sorted)
      commitPaginationFromMeta(commit, response)
    }
  },

  async loadAbout({ commit }, id) {
    const response = await AboutService.show(id)

    commit('SET_ABOUT', response.data)
  },

  async loadContactServiceList({ commit }, page = 1) {
    const response = await ContactService.list(page)

    commit('SET_CONTACT_SERVICES', response.data.data)
    commitPaginationFromLinks(commit, response)
  },

  async loadContactService({ commit }, id) {
    const response = await ContactService.show(id)

    commit('SET_CONTACT_SERVICE', response.data)
  }
}
